import { IRegionCampaign, IRegionCampaignUpdate } from '@/models';
import {
	IRegionCampaignState,
	initialState
} from '@/store/settings/regioncampaigns';

const setCampaigns = (state: IRegionCampaignState) => {
	const campaigns = state.regionCampaigns.data[0];
	if (campaigns) {
		state.campaignSettings = campaigns.campaigns;
	}
};

const setRegionsByCampaign = (state: IRegionCampaignState) => {
	if (!state.campaignSetting) {
		state.regionsByCampaign = initialState.regionsByCampaign;
	} else {
		const regionsByCampaign: IRegionCampaign[] = [];
		state.regionCampaigns.data.forEach(rc => {
			regionsByCampaign.push({
				company: rc.company,
				businessUnit: rc.businessUnit,
				serviceRegion: rc.serviceRegion,
				campaigns: rc.campaigns.filter(
					c => c.key === state.campaignSetting?.key
				)
			});
		});
		state.regionsByCampaign = regionsByCampaign;
	}
};

const setRegionCampaignUpdate = (
	state: IRegionCampaignState,
	regionCampaign: IRegionCampaign
) => {
	const { key, enabled } = regionCampaign.campaigns[0];
	const index = state.regionCampaignUpdates.data.findIndex(
		rcu =>
			rcu.key === key &&
			rcu.company === regionCampaign.company &&
			rcu.businessUnit === regionCampaign.businessUnit &&
			rcu.serviceRegion === regionCampaign.serviceRegion
	);
	if (index === -1) {
		state.regionCampaignUpdates.data.push({
			company: regionCampaign.company,
			businessUnit: regionCampaign.businessUnit,
			serviceRegion: regionCampaign.serviceRegion,
			key: key,
			enabled: !enabled
		});
	} else {
		state.regionCampaignUpdates.data.splice(index, 1);
	}
};

const setRegionChecked = (
	updates: IRegionCampaignUpdate[],
	current: IRegionCampaign
): boolean => {
	const { enabled, key } = current.campaigns[0];
	const index = updates.findIndex(
		u =>
			u.key === key &&
			u.company === current.company &&
			u.businessUnit === current.businessUnit &&
			u.serviceRegion === current.serviceRegion
	);
	return index === -1 ? enabled : updates[index].enabled;
};

export const regionCampaignService = {
	setCampaigns,
	setRegionsByCampaign,
	setRegionCampaignUpdate,
	setRegionChecked
};
